import FooterNavbar from "../../../../footernavbar/FooterNavbar";
import AboutusNavbar from "../AboutusNavbar";

const OurLeadership = () => {
  return (
    <>
      <div className=" display-max">
        <FooterNavbar />
        <AboutusNavbar />
        <div>
          <div className="container w-50 py-5">
            <div className="row mt-0">
              <a href="/OurLeadershipInside">
                <div className="col-6">
                  <div className="card shadow-lg">
                    <div className="card-header p-0 mx-3 mt-3 position-relative z-index-1">
                      <a href="/OurLeadershipInside" className="d-block">
                        <img
                          src="../../assets/img/footer/surajahmed.JPG"
                          className="img-fluid border-radius-lg"
                          alt=""
                        />
                      </a>
                    </div>
                    <div className="card-body text-center pt-3">
                      <h5 className="mt-3 mb-1 d-md-block d-none">
                        Suraj Ahmed{" "}
                      </h5>
                      <p className="mb-0 text-xs font-weight-bolder text-info text-gradient text-uppercase">
                        Founder & CEO
                      </p>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OurLeadership;
